export default "__VITE_ASSET__19fe0d53__"